module.exports = __webpack_public_path__ + "static/media/23.cd443f28.jpg";